<template>
  <div class="item-box">
    <el-row :gutter="40">
      <el-col
        :span="6"
        style="overflow: hidden"
      >
        <div class="item-img">
          <el-image
            :src="imgSrc"
            style="height: 185px;width: 90%;"
            fit="cover"
          />
        </div>
      </el-col>
      <el-col
        :span="18"
        class="item-content-col"
        style="overflow: hidden"
      >
        <div class="item-content">
          <h3 class="content-title">
            <slot name="title" />
          </h3>
          <p class="content-body">
            <span class="body-start">
              <slot name="intro-start-word">
                【简要介绍】
              </slot>
            </span>
            <slot name="content" />
          </p>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'CaseShowListItem',
  props: {
    imgSrc: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="less">
    .item-box{
        margin-bottom: 40px;
      .item-img{
        width: 260px;
        margin: auto;
      }
    }
    .content-title{
      ::v-deep * {
        font-size:24px;
        cursor: pointer;
        font-weight:bold;
        color:rgba(77,77,77,1);
        margin-top: 22px;
        text-overflow:ellipsis; //溢出用省略号显示
        white-space:nowrap; //溢出不换行
        overflow:hidden; //超出的文本隐藏
      }
      font-size:24px;
      cursor: pointer;
      font-weight:bold;
      color:rgba(77,77,77,1);
      margin-top: 22px;
      text-overflow:ellipsis; //溢出用省略号显示
      white-space:nowrap; //溢出不换行
      overflow:hidden; //超出的文本隐藏
    }
    .item-content-col{
        background:rgba(255,255,255,1);
        box-shadow:0px 0px 7px 2px rgba(199,197,197,0.1);
    }
    .content-body{
        position: relative;
        padding-top: 17px;
        padding-left: 110px;
        font-size:18px;

        font-weight:500;
        color:rgba(77,77,77,1);
        border-top: 1px solid rgba(216,216,216,1);;
        .body-start{
            position: absolute;
            left: 0;
            top: 17px;
            color: @--primary-color;
        }
        @{deep} {
            div {
              max-height: 108px;
              width: 100%;
              text-overflow: ellipsis;
              font-size: 18px;
              text-align: left;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 4;
              overflow: hidden;
              line-height: 1.5;
            }
        }
    }
</style>
